// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

// Import utils
import smoothScrollTo from '../../utils/SmoothScrollTo';

class SubscriptionForm {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set module dom sub elements e.g.
    this.subscriptionConfirm = settings.subscriptionConfirm;
    this.subscriptionConfirmMessage = el.querySelector(settings.subscriptionConfirmMessage);
    this.currentUrl = window.location.href;
    this.hash = window.location.hash;

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container) return;
    if (this.currentUrl.indexOf(this.subscriptionConfirm) < 0) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('load', this.changeUrlHash);
    window.addEventListener('load', this.scrollToSubscriptionForm);
  };

  changeUrlHash = () => {
    if (this.currentUrl.indexOf(this.subscriptionConfirm) > 0) {
      this.hash = '#subscriptionConfirm';
    }
  };

  scrollToSubscriptionForm = () => {
    if (this.subscriptionConfirmMessage) {
      smoothScrollTo(this.subscriptionConfirmMessage, 500);
    }
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, SubscriptionForm);
